import { fork, put, takeEvery, all } from 'redux-saga/effects';

import {
  SystemApi,
  SystemControllerDtoSysMaintenanceCreateRequest,
  SystemControllerDtoSysMaintenanceInfoRequest,
  SystemControllerDtoSysMaintenanceListRequest,
  SystemControllerDtoSysMaintenanceRemoveRequest,
  SystemControllerDtoSysMaintenanceUpdateRequest,
} from '../../models/src';
import config from '../../../config/config';
import {
  maintenanceResponse,
  resetMaintenanceDetails,
  setMaintenanceDetails,
  setMaintenanceList,
  setMaintenancePagination,
} from '../../actions/app/maintenanceActions';
import {
  MAINTENANCE_CREATE,
  MAINTENANCE_DETAILS_REQUEST,
  MAINTENANCE_LIST_REQUEST,
  MAINTENANCE_REMOVE,
  MAINTENANCE_TERMINATE,
  MAINTENANCE_UPDATE,
  SET_MAINTENANCE_DETAILS,
} from '../../constants/app/maintenanceConstants';
import BaseResponse from '../../models/src/model/BaseResponse';
import SystemControllerDtoSysMaintenanceListResponse
  from '../../models/src/model/SystemControllerDtoSysMaintenanceListResponse';
import SystemControllerDtoSysMaintenanceInfoResponse
  from '../../models/src/model/SystemControllerDtoSysMaintenanceInfoResponse';
import { getErrorMessage } from '../../../utils/serverErrorCheck';

const api = new SystemApi(config.API_CLIENT);

function* maintenanceListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new SystemControllerDtoSysMaintenanceListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiSystemSysMaintenanceListPost({ systemControllerDtoSysMaintenanceListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, SystemControllerDtoSysMaintenanceListResponse);

    yield put(
      setMaintenancePagination(
        payload.page,
        payload.pageLength,
        data.totalCount,
      ),
    );

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* maintenanceTerminateSaga() {
  try {
    console.log('! ! ! 긴급 점검 ! ! !');
    const result = yield api.apiSystemSysMaintenanceTerminatePost(() => {});
    const data = api.apiClient.deserialize(result, BaseResponse);
    console.log('요청 결과: ', data);
  } catch (e) {
    console.log(e);
  }
}

function* maintenanceCreateSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new SystemControllerDtoSysMaintenanceCreateRequest();
    requestData.isUrgent = payload.isUrgent;
    requestData.title = payload.title;
    requestData.content = payload.content;
    requestData.startedAt = payload.startedAt;
    requestData.endedAt = payload.endedAt;
    requestData.version = payload.version;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiSystemSysMaintenanceCreatePost({ systemControllerDtoSysMaintenanceCreateRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* maintenanceDetailsRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new SystemControllerDtoSysMaintenanceInfoRequest();
    requestData.maintenanceNo = payload.maintenanceNo;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiSystemSysMaintenanceInfoPost({ systemControllerDtoSysMaintenanceInfoRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, SystemControllerDtoSysMaintenanceInfoResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* maintenanceRemoveSaga(payload) {
  try {
    yield put(maintenanceResponse(null));
    const requestData = new SystemControllerDtoSysMaintenanceRemoveRequest();
    requestData.maintenanceNo = payload.maintenanceNo;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiSystemSysMaintenanceRemovePost({ systemControllerDtoSysMaintenanceRemoveRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);
    console.log('요청 결과: ', data);

    yield put(maintenanceResponse(data.resultCode));
  } catch (e) {
    console.log(e);
  }
}

function* maintenanceUpdateSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new SystemControllerDtoSysMaintenanceUpdateRequest();
    requestData.maintenanceNo = payload.maintenanceNo;
    requestData.title = payload.title;
    requestData.content = payload.content;
    requestData.startedAt = payload.startedAt;
    requestData.endedAt = payload.endedAt;
    requestData.version = payload.version;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiSystemSysMaintenanceUpdatePost({ systemControllerDtoSysMaintenanceUpdateRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, BaseResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }

    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* maintenanceRootSaga() {
  yield all([
    takeEvery(MAINTENANCE_LIST_REQUEST, maintenanceListRequestSaga),
    takeEvery(MAINTENANCE_TERMINATE, maintenanceTerminateSaga),
    takeEvery(MAINTENANCE_CREATE, maintenanceCreateSaga),
    takeEvery(MAINTENANCE_DETAILS_REQUEST, maintenanceDetailsRequestSaga),
    takeEvery(SET_MAINTENANCE_DETAILS, setMaintenanceDetails),
    takeEvery(MAINTENANCE_REMOVE, maintenanceRemoveSaga),
    takeEvery(MAINTENANCE_UPDATE, maintenanceUpdateSaga),
  ]);
}

const maintenanceSagas = [fork(maintenanceRootSaga)];

export default maintenanceSagas;
